module.exports = __webpack_public_path__ + "static/media/consumerProduct.2622d65c.svg";